import React, { createContext, useContext } from "react";

import { ILink } from "../../types/thecookies";

export interface LayoutContextType {
  children?: React.ReactNode;
  lang?: string;
  landingName?: string;
  legalLinks?: ILink[];
  navbarLinks?: ILink[];
  settings?: {
    postalAddress?: {
      address?: string;
    };
    email?: string;
    phone?: string;
  };
}

export const LayoutContext = createContext<LayoutContextType>({
  lang: "",
  landingName: "",
  legalLinks: [],
  navbarLinks: [],
});

export const useLayout = () => {
  return useContext(LayoutContext);
};
